// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PcSvg from '@rsuite/icon-font/lib/device/Pc';
var Pc = createSvgIcon({
  as: PcSvg,
  ariaLabel: 'pc',
  category: 'device',
  displayName: 'Pc'
});
export default Pc;